<template>
  <section>
    <div class="new-section contact-us">
      <div class="m-container">
        <div class="row">
          <!-- contact us content text -->
          <div class="col-sm-12 col-md-6 our-courses">
            <!-- <p class="section-head">our courses</p>-->            
            <p class="section-head">OUR COURSES</p>
            <p class="c-us-p">Do you need help or support? Help Desk 24h/7</p>
            <p class="p-number">{{ this.$store.state.settings_website[0].phone }}</p>
            <p class="sent-to-email">Or write to us: <span>{{ this.$store.state.settings_website[0].email }}</span></p>
            <!-- <p style="color:#ACAFB2;">Lorem ipsum dolor sit amet enim. Etiam ullamcorper. Suspendisse a pellentesque dui, non felis.</p> -->
            <p class="section-head">our address</p>
            <p class="c-us-p">{{ this.$store.state.settings_website[0].address }}</p>
          </div>
          <!-- end contact us content text -->

          <!-- start form part -->
          <div class="col-xs-12 col-sm-12 col-md-6 the-form">
            <div class="contact-us-form-body">

              <!-- loading -->
              <q-linear-progress indeterminate v-if="loading"></q-linear-progress>
              <!-- end loading -->

              <!-- form -->
              <q-form @submit.prevent="submit">
                <p class="error" v-for="item in formErrors" :key="item.id">- {{ item }}</p>
                <p class="success" v-if="formDone">{{ formDone }} </p>

                <p class="section-head">contact us</p>
                <p class="c-us-p">If you have any questions, feel free to contact with us</p>

                <!-- form inputs -->

                <label>Your name</label>
                <q-input label-color="secondary" filled v-model="formData.name" label="Enter Your Name" lazy-rules
                         :rules="formRules.nameRules"/>

                <label>Your email</label>
                <q-input reactive-rules label-color="secondary" filled v-model="formData.email" label="Enter Your Email"
                         lazy-rules :rules="formRules.emailRules"/>

                <label>Subject</label>
                <q-input reactive-rules label-color="secondary" filled v-model="formData.subject" label="Enter Subject"
                         lazy-rules :rules="formRules.subjectRules"/>

                <div class="contact-textarea">
                  <label>Message</label>
                  <q-input type="textarea" reactive-rules label-color="secondary" filled
                           v-model="formData.message" label="Enter Message" lazy-rules :rules="formRules.messageRules"/>
                </div>

                <div class="submit">
                  <ButtonComponent>Send message</ButtonComponent>
                  <!-- end send message  button -->
                </div>
              </q-form>
              <!-- end form -->

            </div>
          </div>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
import ButtonComponent from "@/components/tools/ButtonComponent.vue"

export default {
  data: () => ({
    loading: false,
    alert: false,
    formDone: '',
    formErrors: [],
    formData: {
      name: '',
      email: '',
      subject: '',
      organizer_id: '',
      message: '',
    },
    formRules: {
      nameRules: [val => val !== null && val !== '' || 'Please enter your name'],
      emailRules: [val => val !== null && val !== '' || 'Please enter your email'],
      subjectRules: [val => val !== null && val !== '' || 'Please enter subject'],
      messageRules: [val => val !== null && val !== '' || 'Please enter your message', val => val.length >= 25 && val.length <= 300 || 'Your message should be bettwen 25 and 300 characters'],
    }
  }),
  components: {ButtonComponent},
  methods: {
    submit() {

      const formData = new FormData();
      formData.append('name', this.formData.name);
      formData.append('email', this.formData.email);
      formData.append('subject', this.formData.subject);
      formData.append('organizer_id', this.$store.state.InternalSettings[0].organizer_id);
      formData.append('message', this.formData.message);
      //
      this.formErrors = [];
      this.formDone = '';
      // start loading
      this.loading = true;

      this.$API.general.contactUs(formData)
          .then(response => {
            // close loading
            this.loading = false;
            this.$q.notify({
              message: response.message,
              color: 'green'
            })
          })
          .catch(error => {
            // close loading
            this.loading = false;
            this.$q.notify({
              message: error.message,
              color: 'red'
            })
            this.formErrors = error.message;
          });
    },

  },
}
</script>

<style>

.contact-textarea .q-field__control {
  height: auto !important;
}

.contact-textarea .q-field__control-container {
  width: auto;
  max-width: initial !important;
}

.c-us-p {
  font-size: 1.25rem;
  font-weight: bold;
}
.contact-us{ padding: 100px 0 !important;}
.contact-us .our-courses {
  padding: 10% 120px 0px 51px;
}

.contact-us .our-courses > p {
  text-align: left;
  margin-bottom: 30px !important;
}

.contact-us .our-courses .sent-to-email {
  color: var(--secondaryColors);

}

.contact-us .our-courses .sent-to-email span {
  color: var(--mainColors);

}

.contact-us .our-courses .gray-color {
  margin-bottom: 51px !important;
}

.contact-us .the-form .contact-us-form-body {
  max-width: 499px;
  margin: auto;
}

.contact-us .the-form .contact-us-form-body form {
  padding: 25px 60px; border-radius: 4rem;
  box-shadow: 0px 3px 6px 0px rgba(122, 122, 122, 0.31);
  -webkit-box-shadow: 0px 3px 6px 0px rgba(122, 122, 122, 0.31);
  -moz-box-shadow: 0px 3px 6px 0px rgba(122, 122, 122, 0.31);
}

.the-form .contact-us-form-body form > p {
  margin-bottom: 10px !important;
  text-align: left;
}

.the-form .contact-us-form-body form p:nth-child(2) {
  color: var(--secondaryColors);
  font-weight: 500;
}

.the-form label {
  margin: 10px 0px 10px !important;
  font-size: 1rem;
  color: #252634;
}
.the-form .q-field--filled .q-field__control{border-radius: 5px;}

.the-form .contact-us-form-body form .submit {
  text-align: center;
}
.the-form .contact-us-form-body form .submit .the-button .wro-button{width: 205px; height: 60px; border-radius: 30px; box-shadow: none;}
.the-form .contact-us-form-body form .submit .the-button .wro-button span{ font-size: 1.245rem; font-weight: 500;}

.the-form .contact-us-form-body form .the-button {
  margin: 0px;
}

@media (max-width: 1120px) {
  .contact-us .the-form {
    display: flex;
    justify-content: center;
  }
}

@media (max-width: 1079px) {
  .the-form .contact-us-form-body form .submit .the-button .wro-button{width: 185px; height: 50px;}
  .contact-us{ padding: 50px 0 !important;}
  .contact-us .our-courses { padding: 0 120px 0px 51px;}

  .contact-us .our-courses > p { margin-bottom: 20px !important;}
}

@media (max-width: 599px) {
  /*.contact-us .m-container{*/
  /*  padding: 0px;*/
  /*}*/
  .contact-us .the-form .contact-us-form-body form{border-radius: 2rem;}
  p.section-head {
    font-size: 1rem !important;
  }
  .contact-us .our-courses {
    padding: 0px;
  }

  .contact-us .m-container {
    margin: 0px;
  }

  .contact-us .the-form .contact-us-form-body form {
    padding: 25px 30px;
  }
  .the-form .contact-us-form-body form .submit .the-button .wro-button{width: 170px; height: 44px;}
}
</style>